<script lang="ts">
    import { onDestroy, onMount } from "svelte"
    import { getEventCallbacks, registerEventCallback, unregisterEventCallback } from "../eventBus"
    import { spaNavigate } from "../actions"
    import { createEventDispatcher } from "svelte"
    import Modal from "../components/Modal.svelte"
    import hash from "object-hash"
    import Cta from "../components/CTA.svelte"

    export let task: TaskOilSpillRemoval | TaskTowing,
        originalTaskHash: string = null,
        closeRequest: null | ["navigate" | "dispatch" | "callback", any, any] = null,
        originalTask: TaskOilSpillRemoval | TaskTowing

    let dispatcher = createEventDispatcher()
    onDestroy(() => {
        let callbacks = getEventCallbacks("navigate")
        if (callbacks?.["EntryHash"]) unregisterEventCallback("navigate", "EntryHash")
    })
    function registerEvent() {
        if (!getEventCallbacks("navigate")?.["EntryHash"]) {
            originalTaskHash = hash(typeof task == "object" ? task : {})
            registerEventCallback("navigate", "EntryHash", (path: string, props: any) => {
                if (originalTaskHash !== hash(task)) {
                    closeRequest = ["navigate", path, props]
                    return false
                }
                return true
            })
            originalTask = JSON.parse(JSON.stringify(task))
        }
    }
    onMount(() => {
        setTimeout(() => registerEvent(), 10)
    })
    let innerWidth = 0
    $: isMobile = innerWidth < 1700
</script>

<svelte:window bind:innerWidth="{innerWidth}" />
{#if closeRequest}
    <Modal
        show="{true}"
        size="sm"
        on:close="{(e) => (closeRequest = null)}"
    >
        <div slot="header">Eintrag wurde nicht gespeichert</div>
        <p>
            Sie haben ungespeicherte Daten, möchten Sie den Eintrag dennoch ungespeichert verlassen? Klicken Sie auf
            Eintrag Schließen, um ungespeichert zu verlassen. Klicken Sie auf Abbrechen, um doch nicht zu verlassen.
        </p>

        <div slot="footer">
            <Cta
                type="primaryButton"
                content="Abbrechen"
                icon="solar_close-circle-outline"
                on:click="{() => {
                    closeRequest = null
                }}"
            />
            <Cta
                type="tertiaryButton"
                content="{isMobile ? 'Schließen' : 'Eintrag Schließen'}"
                icon="solar_check-read-outline"
                on:click="{() => {
                    unregisterEventCallback('navigate', 'EntryHash')
                    if (closeRequest[0] === 'dispatch') dispatcher(closeRequest[1], closeRequest[2])
                    else if (closeRequest[0] === 'callback') closeRequest[1]()
                    else spaNavigate(closeRequest[1], closeRequest[2])
                    closeRequest = null
                }}"
            />
        </div>
    </Modal>
{/if}
